<div class="modal-header">
    <h4 class="modal-title">{{'LostConnectionmModal.title' | translate}}</h4>
</div>
<div class="lost-connect-body">
    <p>{{'LostConnectionmModal.body' | translate}}</p>
</div>